import React, { useState, useEffect } from 'react';
import { Box, Typography, Container, Paper, Grid, ButtonBase } from '@mui/material';
import { useChowaTheme } from '../config/chowaThemeContext';
import { createChowaUnit, updateChowaUnit } from '../api_config';
import NewUnitForm from './NewUnitForm';
import EditUnits from './EditUnits';
import SeriesManagement from './SeriesManagement';

const UnitManagement = () => {
  const { getCurrentTheme } = useChowaTheme();
  const currentTheme = getCurrentTheme();
  const [units] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentView, setCurrentView] = useState('list'); // 'list', 'new', 'edit', 'edit-form', 'series'
  const [editingUnit, setEditingUnit] = useState(null);



  useEffect(() => {
    // TODO: ユニットデータを取得するAPI呼び出し
    // 現在はダミーデータ
    setLoading(false);
  }, []);



  const handleNewUnit = () => {
    setCurrentView('new');
  };

  const handleEditUnits = () => {
    setCurrentView('edit');
  };

  const handleEditUnit = (unit) => {
    setEditingUnit(unit);
    setCurrentView('edit-form');
  };

  const handleBackToEdit = () => {
    setCurrentView('edit');
    setEditingUnit(null);
  };



  const handleBackToList = () => {
    setCurrentView('list');
  };

  const handleSaveNewUnit = async (newUnitData) => {
    try {
      console.log('新規ユニット保存:', newUnitData);
      
      if (editingUnit) {
        // 編集モード
        const response = await updateChowaUnit(editingUnit.id, newUnitData);
        if (response.data.status === 'success') {
          console.log('ユニット更新成功:', response.data);
          alert('ユニットが正常に更新されました');
        } else {
          console.error('ユニット更新エラー:', response.data.message);
          // デバイスID重複エラーの場合は詳細メッセージを表示
          if (response.data.message && response.data.message.includes('Device ID')) {
            alert(`デバイスID重複エラー: ${response.data.message}`);
          } else {
            alert(response.data.message || 'ユニット更新に失敗しました');
          }
        }
      } else {
        // 新規作成モード
        const response = await createChowaUnit(newUnitData);
        if (response.data.status === 'success') {
          console.log('ユニット作成成功:', response.data);
          alert('新規ユニットが正常に作成されました');
        } else {
          console.error('ユニット作成エラー:', response.data.message);
          // デバイスID重複エラーの場合は詳細メッセージを表示
          if (response.data.message && response.data.message.includes('Device ID')) {
            alert(`デバイスID重複エラー: ${response.data.message}`);
          } else {
            alert(response.data.message || 'ユニット作成に失敗しました');
          }
        }
      }
      
      setCurrentView('list');
      setEditingUnit(null);
    } catch (error) {
      console.error('ユニット保存エラー:', error);
      if (error.response && error.response.data && error.response.data.message) {
        alert(error.response.data.message);
      } else {
        alert('ユニット保存中にエラーが発生しました');
      }
    }
  };



  const renderContent = () => {
    switch (currentView) {
      case 'new':
        return <NewUnitForm onBack={handleBackToList} onSave={handleSaveNewUnit} />;
      case 'edit':
        return <EditUnits onBack={handleBackToList} onEdit={handleEditUnit} />;
      case 'edit-form':
        return <NewUnitForm onBack={handleBackToEdit} onSave={handleSaveNewUnit} initialData={editingUnit} isEditMode={true} />;
              case 'series':
          return <SeriesManagement />;
      default:
        return (
          <Paper elevation={2} sx={{ p: 2 }}>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
              ユニット一覧
            </Typography>
            
            {units.length === 0 ? (
              <Box sx={{ textAlign: 'center', py: 8 }}>
                <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
                  登録されているユニットがありません
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  新しいユニットを追加してください
                </Typography>
              </Box>
            ) : (
              <Typography variant="body1" color="text.secondary">
                ユニット一覧がここに表示されます
              </Typography>
            )}
          </Paper>
        );
    }
  };

  if (loading) {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Box sx={{ textAlign: 'center', py: 8 }}>
          <Typography variant="h6" color="text.secondary">
            データを読み込み中...
          </Typography>
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth={false} sx={{ py: 2, px: 1 }}>






      {/* メインコンテンツ */}
      <Grid container spacing={2}>
        {/* シリーズ管理 */}
        <Grid item xs={12} sm={6} md={4}>
          <ButtonBase
            onClick={() => setCurrentView('series')}
            sx={{ width: '100%', textAlign: 'left' }}
          >
            <Paper 
              elevation={2} 
              sx={{ 
                p: 1.5, 
                textAlign: 'center',
                borderTop: `4px solid ${currentTheme.accent || '#f59e0b'}`,
                width: '100%',
                transition: 'all 0.2s ease-in-out',
                '&:hover': {
                  transform: 'translateY(-2px)',
                  boxShadow: 4
                }
              }}
            >
              <Typography 
                variant="h5" 
                sx={{ 
                  fontWeight: 600, 
                  color: currentTheme.accent || '#f59e0b',
                  mb: 2
                }}
              >
                シリーズ管理
              </Typography>
              <Typography variant="body2" color="text.secondary">
                機種シリーズの追加・編集
              </Typography>
            </Paper>
          </ButtonBase>
        </Grid>

        {/* ユニット編集 */}
        <Grid item xs={12} sm={6} md={4}>
          <ButtonBase
            onClick={handleEditUnits}
            sx={{ width: '100%', textAlign: 'left' }}
          >
            <Paper 
              elevation={2} 
              sx={{ 
                p: 1.5, 
                textAlign: 'center',
                borderTop: `4px solid ${currentTheme.secondary || '#10b981'}`,
                width: '100%',
                transition: 'all 0.2s ease-in-out',
                '&:hover': {
                  transform: 'translateY(-2px)',
                  boxShadow: 4
                }
              }}
            >
              <Typography 
                variant="h5" 
                sx={{ 
                  fontWeight: 600, 
                  color: currentTheme.secondary || '#10b981',
                  mb: 2
                }}
              >
                ユニット編集
              </Typography>
              <Typography variant="body2" color="text.secondary">
                既存ユニットを編集します
              </Typography>
            </Paper>
          </ButtonBase>
        </Grid>

        {/* 新規ユニット登録 */}
        <Grid item xs={12} sm={6} md={4}>
          <ButtonBase
            onClick={handleNewUnit}
            sx={{ width: '100%', textAlign: 'left' }}
          >
            <Paper 
              elevation={2} 
              sx={{ 
                p: 1.5, 
                textAlign: 'center',
                borderTop: `4px solid ${currentTheme.primary}`,
                width: '100%',
                transition: 'all 0.2s ease-in-out',
                '&:hover': {
                  transform: 'translateY(-2px)',
                  boxShadow: 4
                }
              }}
            >
              <Typography 
                variant="h5" 
                sx={{ 
                  fontWeight: 600, 
                  color: currentTheme.primary,
                  mb: 2
                }}
              >
                新規ユニット登録
              </Typography>
              <Typography variant="body2" color="text.secondary">
                新しいユニットを追加します
              </Typography>
            </Paper>
          </ButtonBase>
        </Grid>

        {/* 動的コンテンツ */}
        <Grid item xs={12}>
          {renderContent()}
        </Grid>
      </Grid>
    </Container>
  );
};

export default UnitManagement;
